"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Bulkhead = _interopRequireDefault(require("./Bulkhead.proptypes"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var BulkheadTile = _styledComponents.default.div.withConfig({
  displayName: "Bulkhead__BulkheadTile",
  componentId: "sc-uxnzdr-0"
})(["width:", ";height:", ";background:", ";border-radius:", ";"], function (_ref) {
  var width = _ref.width;
  return width ? "".concat(width, "px") : '100%';
}, function (_ref2) {
  var height = _ref2.height,
    theme = _ref2.theme;
  return height ? "".concat(height, "px") : theme.space.small;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.greyLight;
}, function (_ref4) {
  var borderRadius = _ref4.borderRadius,
    theme = _ref4.theme;
  return borderRadius ? "".concat(borderRadius, "px") : theme.space.micro;
});
var Bulkhead = function Bulkhead(_ref5) {
  var accessible = _ref5.accessible,
    theme = _ref5.theme,
    customProperties = _ref5.customProperties,
    width = _ref5.width,
    height = _ref5.height,
    borderRadius = _ref5.borderRadius;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(BulkheadTile, {
      accessible: accessible,
      customProperties: customProperties,
      width: width,
      height: height,
      borderRadius: borderRadius
    });
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
Bulkhead.propTypes = _Bulkhead.default.PropTypes;
Bulkhead.defaultProps = _Bulkhead.default.DefaultProps;
var _default = Bulkhead;
exports.default = _default;